<template>
  <div>
    <Head :title="title" />
    <div class="bg-white rounded-md shadow overflow-hidden max-w-full">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <select-input-filter
            v-if="user_access.ticket.update && !(auth.user.role.slug === 'customer' || auth.user.role.slug === 'general')"
            v-model="form.user_id"
            placeholder="Start typing"
            :on-input="doFilter"
            :items="customers"
            :error="form.errors.user_id"
            class="pr-6 pb-8 w-full lg:w-1/3"
            :label="__('Requester')"
            required="true"
          />

          <select-input-filter
            v-model="form.channel_id"
            :error="form.errors.channel_id"
            class="pr-6 pb-8 w-full lg:w-1/3"
            :label="__('Channel Requester')"
            placeholder="Cari channel..."
            :on-input="doFilterChannels"
            :items="filteredChannels"
            :disabled="isCustomerChannelLocked || isRequesterChannelLocked"
            @focus="doFilterChannels"
          />

          <select-input
            v-if="user_access.ticket.update && !(auth.user.role.slug === 'customer' || auth.user.role.slug === 'general')"
            v-model="form.priority_id"
            :error="form.errors.priority_id"
            class="pr-6 pb-8 w-full lg:w-1/3"
            :label="__('Priority')"
          >
            <option :value="null" />
            <option v-for="s in priorities" :key="s.id" :value="s.id">{{ s.name }}</option>
          </select-input>

          <select-input
            v-if="user_access.ticket.update && !(auth.user.role.slug === 'customer' || auth.user.role.slug === 'general')"
            v-model="form.levelquantity_id"
            :error="form.errors.levelquantity_id"
            class="pr-6 pb-8 w-full lg:w-1/3"
            :label="__('Level Quantity')"
          >
            <option :value="null" />
            <option v-for="s in levelquantities" :key="s.id" :value="s.id">{{ s.name }}</option>
          </select-input>

          <select-input
            v-if="user_access.ticket.update && !(auth.user.role.slug === 'customer' || auth.user.role.slug === 'general')"
            v-model="form.levelquality_id"
            :error="form.errors.levelquality_id"
            class="pr-6 pb-8 w-full lg:w-1/3"
            :label="__('Level Quality')"
          >
            <option :value="null" />
            <option v-for="s in levelqualities" :key="s.id" :value="s.id">{{ s.name }}</option>
          </select-input>

          <!-- CUSTOM DEPARTMENT LIMIT -->
          <select-input
            v-model="form.department_id"
            :error="form.errors.department_id"
            class="pr-6 pb-5 md:col-span-6 lg:w-1/3"
            :label="__('Department')"
            required="true"
            @change="handleDepartmentChange"
          >
            <option :value="null">{{ __('Select a department') }}</option>
            <option v-for="department in departments" :key="department.id" :value="department.id">
              {{ department.name }}
            </option>
          </select-input>
          <div
            v-if="showWhatsAppPopup"
            class="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4"
            @click.self="closePopup"
          >
            <div class="bg-white p-8 rounded-xl shadow-2xl max-w-lg w-full text-center space-y-5">
              <!-- Heading -->
              <h2 class="text-2xl font-bold text-red-600">
                Kuota Ticket BNC Penuh
              </h2>

              <!-- Description -->
              <p class="text-gray-700 leading-relaxed text-base">
                Kuota ticket <strong>Brandcomm Creative Fulfillment</strong> hari ini sudah penuh
                ({{ customer_ticket_info?.total_dept3_today }}/10).
                Silakan hubungi admin melalui WhatsApp untuk konfirmasi.
              </p>

              <!-- Actions -->
              <div class="flex flex-col sm:flex-row items-center justify-center gap-4 pt-2">
                <button
                  class="px-5 py-2.5 bg-gray-200 hover:bg-gray-300 rounded-lg text-gray-800 font-medium w-full sm:w-auto"
                  @click="showWhatsAppPopup = false"
                >
                  Tutup
                </button>

                <a
                  :href="`https://wa.me/${ADMIN_PHONE}?text=${encodeURIComponent(
                    `Halo Admin, saya ingin membuat ticket ke BNC. Kuota hari ini sudah penuh (${customer_ticket_info?.total_dept3_today}/10). Mohon bantuannya.`
                  )}`"
                  target="_blank"
                  class="px-5 py-2.5 bg-green-600 hover:bg-green-700 text-white rounded-lg font-semibold w-full sm:w-auto"
                >
                  Hubungi Admin
                </a>
              </div>
            </div>
          </div>
          <!-- END CUSTOM DEPARTMENT LIMIT -->

          <select-input-filter
            v-if="!(hidden_fields && hidden_fields.includes('category')) && form.department_id"
            ref="category"
            v-model="form.category_id"
            placeholder="Cari kategori..."
            :on-input="doFilterCategories"
            :items="filteredCategories"
            :error="form.errors.category_id"
            class="pb-5 pr-6 md:col-span-6 lg:w-1/3"
            :label="__('Category')"
            required="true"
            @focus="doFilterCategories"
          />

          <select-input-filter
            v-model="form.assigned_to"
            placeholder="Start typing"
            :on-input="doFilterUsersExceptCustomer"
            v-if="form.department_id"
            :items="filteredUsersExceptCustomers"
            :error="form.errors.assigned_to"
            class="pr-6 pb-8 w-full lg:w-1/3"
            :label="__('Assigned to')"
            :required="true"
            @focus="doFilterUsersExceptCustomer"
          />

          <select-input v-if="!(hidden_fields && hidden_fields.includes('ticket_type'))" v-model="form.type_id" :error="form.errors.type_id" class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Ticket Type')" :required="true">
            <option :value="null" />
            <option v-for="s in types" :key="s.id" :value="s.id">{{ s.name }}</option>
          </select-input>

          <select-input
            v-if="form.department_id === 3"
            v-model="form.performance_category"
            :error="form.errors.performance_category"
            class="pr-6 pb-8 w-full lg:w-1/3"
            :label="__('Performance Ticket')"
            required
          >
            <option :value="null">{{ __('Select performance') }}</option>
            <option value="performing">Performing Ticket</option>
            <option value="non_performing">Non-Performing Ticket</option>
          </select-input>

          <div v-if="form.type_id === 9" class="pr-6 pb-8 w-full lg:w-1/3">
            <label class="form-label">Tanggal Deadline</label>
            <input type="date" class="ticket-filter-input w-full" v-model="form.deadline"
                   @focus="$event.target.showPicker?.()"
                   @mousedown="onDateMousedown($event)" />
          </div>

          <div v-if="(auth.user.role.slug !== 'agency' && form.department_id === 3)" class="pr-6 pb-8 w-full lg:w-1/3">
            <label class="form-label">Tanggal Asset Digunakan</label>
            <input type="date" class="ticket-filter-input w-full" v-model="form.date_usedto"
                   @focus="$event.target.showPicker?.()"
                   @mousedown="onDateMousedown($event)" />
          </div>

          <div v-if="(form.type_id === 9 && form.department_id === 3 )" class="pr-6 pb-8 w-full lg:w-1/3">
            <label class="form-label">Total Output</label>
            <text-input v-model="form.total_output_bram" :error="form.errors.total_output_bram" placeholder="Isi hanya dengan angka..." />
          </div>

          <div class="basis-full"></div>
          <hr class="w-full border-t-2 border-gray-200 mb-2" />
          <div class="pr-6 pb-8 w-1/2">
            <cc-input v-model="form.cc_user_ids" :available-users="cc_available_users" :error="form.errors.cc_user_ids" />
          </div>
          <div class="basis-full"></div>
          <text-input v-model="form.subject" :error="form.errors.subject" class="pr-6 pb-8 w-full lg:w-full" :label="__('Subject')" :is_required="true" />
          <div class="pr-6 pb-8 w-full">
            <label class="form-label">Request Details: <span class="text-red-500">*</span></label>
            <tiptap-editor v-model="form.details" />
            <div v-if="form.errors.details" class="form-error">{{ form.errors.details }}</div>
          </div>
          <input ref="file" type="file" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf, .zip" class="hidden" multiple="multiple" @change="fileInputChange" />
          <div class="pr-6 pb-8 w-full">
            <div
              class="upload-zone"
              :class="{ 'upload-zone--dragging': isDragging }"
              @click="fileBrowse"
              @dragover.prevent="isDragging = true"
              @dragleave.prevent="isDragging = false"
              @drop.prevent="onDrop"
            >
              <div class="upload-zone__icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5" />
                </svg>
              </div>
              <div class="upload-zone__text">
                <span class="upload-zone__title">{{ isDragging ? 'Lepaskan file di sini' : __('Attach files') }}</span>
                <span class="upload-zone__hint">XLS, DOC, PPT, PDF, ZIP, gambar — atau drag &amp; drop ke sini</span>
              </div>
            </div>

            <div v-if="form.files.length" class="upload-file-list">
              <div v-for="(file, fi) in form.files" :key="fi" class="upload-file-item">
                <div class="upload-file-item__icon">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
                  </svg>
                </div>
                <div class="upload-file-item__info">
                  <span class="upload-file-item__name">{{ file.name }}</span>
                  <span class="upload-file-item__size">{{ getFileSize(file.size) }}</span>
                </div>
                <button type="button" class="upload-file-item__remove" @click="fileRemove(file, fi)" title="Hapus">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">
            {{ __('Create') }}
            {{ __('Ticket') }}
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Link, Head } from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import SelectInputFilter from '@/Shared/SelectInputFilter'
import TextareaInput from '@/Shared/TextareaInput'
import LoadingButton from '@/Shared/LoadingButton'
import TiptapEditor from '@/Shared/TiptapEditor.vue'
import CcInput from '@/Shared/CcInput.vue'
import axios from 'axios'

export default {
    metaInfo() {
        return { title: this.form.name }
    },
    components: {
        LoadingButton,
        SelectInput,
        SelectInputFilter,
        TextInput,
        TextareaInput,
        Link,
        Head,
        Icon,
        TiptapEditor,
        CcInput,
    },
    layout: Layout,
    props: {
        title: String,
        customers: Array,
        usersExceptCustomers: Array,
        priorities: Array,
        urgencies: Array,
        levelqualities: Array,
        levelquantities: Array,
        statuses: Array,
        types: Array,
        departments: Array,
        channels: Array,
        deadline: Object,
        date_usedto: Object,
        auth: Object,
        hidden_fields: Object,
        all_categories: Array,

        // ⭐ ADDED
        customer_ticket_info: Object,
        cc_available_users: { type: Array, default: () => [] },
    },
    remember: false,

    data() {
        return {
            user_access: this.$page.props.auth.user.access,
            categories: [],
            filteredCategories: [],
            filteredUsersExceptCustomers: [],
            filteredChannels: [],

            form: this.$inertia.form({
                user_id: null,
                priority_id: null,
                urgency_id: null,
                levelquantity_id: null,
                levelquality_id: null,
                status_id: null,
                department_id: null,
                category_id: null,
                channel_id: null,
                assigned_to: null,
                type_id: null,
                performance_category: null,
                subject: null,
                deadline: null,
                date_usedto: null,
                total_output_bram: null,
                details: '',
                files: [],
                cc_user_ids: [],
            }),

            date: null,
            isDragging: false,

            // ⭐ ADDED: popup WA
            showWhatsAppPopup: false,
            ADMIN_PHONE: '6281214044948',
            BNC_DEPT_ID: 3,
        }
    },

    // ⭐ ADDED
    computed: {
        isCustomer() {
            const slug = this.auth.user.role.slug
            return slug === 'customer' || slug === 'general'
        },
        isCustomerChannelLocked() {
            return this.isCustomer && !!this.auth.user.channel_id
        },
        selectedRequesterChannelId() {
            const requester = this.customers.find(c => c.id === this.form.user_id)
            return requester ? requester.channel_id : null
        },
        isRequesterChannelLocked() {
            return !this.isCustomer && !!this.selectedRequesterChannelId
        },
        isBNC() {
            return Number(this.form.department_id) === Number(this.BNC_DEPT_ID)
        },
        isLimitReached() {
            return this.customer_ticket_info?.limit_reached === true
        },
        whatsappLink() {
            const msg =
                'Halo Admin, saya ingin membuat ticket ke Brandcomm Creative Fulfillment ' +
                `namun kuota hari ini sudah penuh (${this.customer_ticket_info?.total_dept3_today}/10). ` +
                'Mohon bantuannya.'

            return `https://wa.me/${this.ADMIN_PHONE}?text=${encodeURIComponent(msg)}`
        },
        // closePopup() {
        //     this.showWhatsAppPopup = false
        // },
    },

    watch: {
        'form.user_id'(newVal) {
            if (this.isCustomer) return

            const requester = this.customers.find(c => c.id === newVal)
            this.form.channel_id = requester?.channel_id ?? null
        },
    },

    created() {
        this.setDefaultValue(this.statuses, 'status_id', 'Pending')
        this.filteredUsersExceptCustomers = [...this.usersExceptCustomers]
        this.filteredChannels = [...this.channels]

        const slug = this.auth.user.role.slug
        if ((slug === 'customer' || slug === 'general') && this.auth.user.channel_id) {
            this.form.channel_id = this.auth.user.channel_id
        }
    },

    methods: {
        onDateMousedown(e) {
            const input = e.target
            if (document.activeElement !== input) return
            requestAnimationFrame(() => {
                if (document.activeElement === input) input.blur()
            })
        },
        closePopup() {
          this.showWhatsAppPopup = false
        },

        // ⭐ UPDATED: dipanggil juga oleh handleDepartmentChange
        getCategories(){
            this.categories = this.all_categories.filter(cat => cat.department_id === this.form.department_id)
            this.filteredCategories = [...this.categories]
            this.form.category_id = null

            if (this.$refs.category) {
                this.$refs.category.selected = null
            }

            this.getUsersByDepartment()
            this.form.assigned_to = null
        },

        doFilterCategories(e){
            const searchTerm = (e.target ? e.target.value : e || '').toLowerCase()
            this.filteredCategories = this.categories.filter(cat => cat.name.toLowerCase().includes(searchTerm))
        },

        // ⭐ ADDED: Handler untuk popup WA
        handleDepartmentChange() {
            this.getCategories()

            if (this.isBNC && this.isLimitReached) {
                this.showWhatsAppPopup = true
            }
        },

        getUsersByDepartment(){
            if (this.form.department_id) {
                this.filteredUsersExceptCustomers = this.usersExceptCustomers.filter(user => {
                    return user.department_id == this.form.department_id ||
                           user.dept_id == this.form.department_id ||
                           (user.department && user.department.id == this.form.department_id)
                })

                this.filteredUsersExceptCustomers = this.filteredUsersExceptCustomers.map(user => ({
                    ...user,
                    name: user.name || (user.first_name + ' ' + user.last_name).trim(),
                }))

                if (this.filteredUsersExceptCustomers.length > 0) return

                axios.get(this.route('filter.users_by_department'), {
                    params: { department_id: this.form.department_id },
                }).then(res => {
                    this.filteredUsersExceptCustomers.splice(0, this.filteredUsersExceptCustomers.length, ...res.data)
                })
            } else {
                this.filteredUsersExceptCustomers = [...this.usersExceptCustomers].map(user => ({
                    ...user,
                    name: user.name || (user.first_name + ' ' + user.last_name).trim(),
                }))
            }
        },

        doFilterChannels(e) {
            const search = (e?.target ? e.target.value : e || '').toLowerCase()
            this.filteredChannels = this.channels.filter(c => c.name.toLowerCase().includes(search))
        },

        doFilter(e){
            axios.get(this.route('filter.customers', {search: e.target.value}))
                .then(res => this.customers.splice(0, this.customers.length, ...res.data))
        },

        doFilterUsersExceptCustomer(e){
            const searchTerm = e.target ? e.target.value : e

            if (this.form.department_id) {
                axios.get(this.route('filter.users_by_department'), {
                    params: { department_id: this.form.department_id, search: searchTerm },
                }).then((res)=> {
                    this.filteredUsersExceptCustomers.splice(0, this.filteredUsersExceptCustomers.length, ...res.data)
                }).catch(() => {
                    const departmentUsers = this.usersExceptCustomers.filter(user =>
                        user.department_id == this.form.department_id,
                    )

                    let filtered = searchTerm
                        ? departmentUsers.filter(user => {
                            const fullName = (user.first_name + ' ' + user.last_name).toLowerCase()
                            const email = (user.email || '').toLowerCase()
                            const s = searchTerm.toLowerCase()
                            return fullName.includes(s) || email.includes(s)
                        })
                        : departmentUsers

                    filtered = filtered.map(user => ({
                        ...user,
                        name: (user.first_name + ' ' + user.last_name).trim(),
                    }))

                    this.filteredUsersExceptCustomers.splice(0, this.filteredUsersExceptCustomers.length, ...filtered)
                })
            } else {
                axios.get(this.route('filter.users_except_customer', {search: searchTerm}))
                    .then(res => this.filteredUsersExceptCustomers.splice(0, this.filteredUsersExceptCustomers.length, ...res.data))
            }
        },

        setDefaultValue(arr, key, value){
            const find = arr.find(i => i.name.match(new RegExp(value + '.*')))
            if(find) this.form[key] = find['id']
        },

        onDrop(e) {
            this.isDragging = false
            const dropped = Array.from(e.dataTransfer.files)
            dropped.forEach(f => this.form.files.push(f))
        },

        fileInputChange(e) {
            let selectedFiles = e.target.files
            for (let i = 0; i < selectedFiles.length; i++) {
                this.form.files.push(selectedFiles[i])
            }
        },

        fileRemove(image, index) {
            this.form.files.splice(index, 1)
        },

        getFileSize(size) {
            const i = Math.floor(Math.log(size) / Math.log(1024))
            return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B','kB','MB','GB','TB'][i]
        },

        fileBrowse() {
            this.$refs.file.click()
        },

        store() {
            if (this.auth.user.role.slug === 'customer' || this.auth.user.role.slug === 'general') {
                this.form.user_id = this.auth.user.id
            }
            this.form.post(this.route('tickets.store'), {
                onError: () => {
                    this.$nextTick(() => {
                        const el = document.querySelector('.form-error, .form-input.error, .form-select.error')
                        if (el && el.scrollIntoView) {
                            el.scrollIntoView({ behavior: 'smooth', block: 'center' })
                        } else {
                            window.scrollTo({ top: 0, behavior: 'smooth' })
                        }
                    })
                },
            })
        },
    },
}
</script>

